import { gql } from "generated-graphql";

/** The newest invoice date supplies the default for all three Invoice Tracking tabs. */
export const LATEST_INVOICE_DATE_QUERY = gql(`
  query LatestInvoiceDate($tenantId: ID!) {
    wasteInvoices(
      tenantId: $tenantId
      pageSize: 1
      sort: [{ field: "invoiceDate", sort: "desc" }]
    ) {
      items {
        id
        invoiceDate
      }
    }
  }
`);
